angular.module("componentes").controller("GoogleMapCtrl", [
	function () {
		"use strict";
	}
]);
